module.exports = __webpack_public_path__ + "static/media/8OLA5.2cf03a30.jpg";